(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rental"] && !Shopify.designMode) return;
  try {
    
  class RentalVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.playBtn = this.querySelector('[data-rental-play]');
      this.backBtn = this.querySelector('[data-rental-back]');
      this.forwardBtn = this.querySelector('[data-rental-forward]');
      this.progress = this.querySelector('[data-rental-seek]');
      this.fill = this.querySelector('.rental__video-progress-fill');
      this.knob = this.querySelector('.rental__video-progress-knob');
      this.currentEl = this.querySelector('[data-rental-current]');
      this.remainingEl = this.querySelector('[data-rental-remaining]');
      this.dragging = false;

      if (this.playBtn) {
        this.playBtn.addEventListener('click', () => {
          if (this.video.paused) this.video.play();
          else this.video.pause();
        });
      }
      if (this.backBtn) {
        this.backBtn.addEventListener('click', () => {
          this.video.currentTime = Math.max(0, this.video.currentTime - 10);
        });
      }
      if (this.forwardBtn) {
        this.forwardBtn.addEventListener('click', () => {
          this.video.currentTime = Math.min(this.video.duration || 0, this.video.currentTime + 10);
        });
      }

      this.video.addEventListener('play', () => this.setAttribute('data-playing', ''));
      this.video.addEventListener('pause', () => this.removeAttribute('data-playing'));
      this.video.addEventListener('timeupdate', () => this.render());
      this.video.addEventListener('loadedmetadata', () => this.render());

      if (this.progress) {
        const seekTo = (clientX) => {
          const rect = this.progress.getBoundingClientRect();
          const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
          if (this.video.duration) this.video.currentTime = ratio * this.video.duration;
        };
        this.progress.addEventListener('pointerdown', (e) => {
          this.dragging = true;
          this.progress.setPointerCapture(e.pointerId);
          seekTo(e.clientX);
        });
        this.progress.addEventListener('pointermove', (e) => {
          if (this.dragging) seekTo(e.clientX);
        });
        this.progress.addEventListener('pointerup', () => { this.dragging = false; });
      }

      if (!this.video.paused) this.setAttribute('data-playing', '');

      // Best-effort muted autoplay: the `autoplay` attribute alone is ignored by
      // some browsers, so also kick it off from JS. Guaranteed-muted so autoplay
      // policies allow it. If still blocked (e.g. iOS Low Power Mode), this fails
      // silently and the play button still works.
      this.video.muted = true;
      const playPromise = this.video.play();
      if (playPromise && playPromise.catch) playPromise.catch(() => {});

      this.render();
    }

    format(seconds) {
      if (!isFinite(seconds)) seconds = 0;
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    render() {
      const dur = this.video.duration || 0;
      const cur = this.video.currentTime || 0;
      const ratio = dur ? cur / dur : 0;
      if (this.fill) this.fill.style.width = ratio * 100 + '%';
      if (this.knob) this.knob.style.left = ratio * 100 + '%';
      if (this.currentEl) this.currentEl.textContent = this.format(cur);
      if (this.remainingEl) this.remainingEl.textContent = '-' + this.format(dur - cur);
    }
  }

  if (!customElements.get('rental-video')) {
    customElements.define('rental-video', RentalVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
